import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import type { RootState } from "@store/store";

interface ResetRouteProps {
  children: React.ReactNode;
}

const ResetRoute = ({ children }: ResetRouteProps) => {
  const resetToken = useSelector((state: RootState) => state.user.resetToken);

  if (!resetToken) {
    return <Navigate to={BROWSER_ROUTES.VERIFY_OTP} replace />;
  }

  return <>{children}</>;
};

export default ResetRoute;
